module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
    var constants = require('Constants.js');

    ; __append("\r\n<div class=\"row prop-sublabel form-group-flex\">\r\n    <input type=\"checkbox\" name=\"hasTitle\" style=\"margin-left: 15px;\" class=\"form-radio-group\">\r\n    <label class=\"form-group-label\">&nbsp;Show Header</label>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 subsection nopadding-r\">\r\n        <label class=\"prop-sublabel label-95\">Caption</label>\r\n        <div>\r\n            <input type=\"text\" name=\"titleText\" class=\"")
    ; __append(escapeFn( titleText !== '' ? 'translatable' : '' ))
    ; __append("\" data-attr=\"titleText\" maxLength=\"")
    ; __append(escapeFn( constants.GROUP_HEADER_MAX_CHAR ))
    ; __append("\" value=\"")
    ; __append(escapeFn( titleText ))
    ; __append("\" />\r\n        </div>\r\n    </div>\r\n</div>\r\n<div class=\"row\" style='")
    ; __append(escapeFn( mobileDesignerStyle ))
    ; __append("'>\r\n    <div class=\"col-md-12 subsection nopadding-r\">\r\n        <label class=\"prop-sublabel label-95\">Header Height</label> \r\n        <div>\r\n            <input type=\"text\" name=\"titleHeight\" class=\"label-45\" value=\"")
    ; __append(escapeFn(titleHeight))
    ; __append("\"/>&nbsp;px\r\n        </div>\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 subsection nopadding-r\">\r\n        <label class=\"prop-sublabel label-95\">Header Alignment</label> \r\n        <div>                \r\n            <img id=\"align-left\" name=\"align-left\" src=\"")
    ; __append( require('editor/icons/align_left.png') )
    ; __append("\" style=\"background-color: ")
    ; __append(escapeFn( alignLeftSelection ))
    ; __append("\" />\r\n            <img id=\"align-center\" name=\"align-center\" src=\"")
    ; __append( require('editor/icons/align_center.png') )
    ; __append("\"  style=\"background-color: ")
    ; __append(escapeFn( alignCenterSelection ))
    ; __append("\" />\r\n            <img id=\"align-right\" name=\"align-right\" src=\"")
    ; __append( require('editor/icons/align_right.png') )
    ; __append("\"  style=\"background-color: ")
    ; __append(escapeFn( alignRightSelection ))
    ; __append("\" />\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}